export default "__VITE_ASSET__2XF1Yyjf__"